import React from "react"
import useAdminActiveCity from "../../../hooks/useAdminActiveCity"
import AdminCityDetail from "../Cities/CityDetail"
import AdminPlatformDashboard from "./Dashboard"

/**
 * /admin/dashboard entry:
 * - super_admin → platform-wide Admin Dashboard
 * - city admin (type: admin) → City Detail stats for header-selected city
 */
const AdminDashboardEntry = () => {
  const { isCityAdmin, activeCityId, activeCity } = useAdminActiveCity()

  if (isCityAdmin) {
    return (
      <AdminCityDetail
        key={activeCityId || "no-city"}
        cityId={activeCityId}
        initialCity={activeCity}
      />
    )
  }

  return <AdminPlatformDashboard />
}

export default AdminDashboardEntry
